import sevenroomsLogo from '@sevenrooms/ui-kit/images/SevenRoomsLogo.svg'
import { Box, Image } from '@sevenrooms/ui-kit/layout'

export function ErrorHeader() {
  return (
    <Box width="100%" textAlign="center" p="m">
      <Image height="40px" src={sevenroomsLogo} alt="SevenRooms Logo" />
    </Box>
  )
}
